import React from 'react';
import styled from 'styled-components';
import theme from '../theme'

const StyledPage = styled.div`
    padding-left: 10%;
    padding-right: 10%;    
    background-color: ${theme.colors.white};
    background-size: auto 100%;
`

const Page = (props) => {
    return (        
        <StyledPage className="section" style={props.backgroundImg && {backgroundImage: "url(" + props.backgroundImg + ")"}}>                                                          
            {props.children}                               
        </StyledPage>        
    )    
}

export default Page;